import ctaLinkTrackingHelper from './cta-link-tracking-helper';
import datadogRumHelper from './datadog-rum-helper';
import driftHelper from './drift-helper';
import optimizelyHelper from './optimizely-helper';
import modalHelper from './modal-helper';
import munchkinHelper from './munchkin-helper';
import oneLinkHelper from './onelink-helper';

export const TRACKERS_INITIALIZED: Sq.Tracking.ObserverName = 'sq:trackersInitialized';
export const CDP_TRACKER_INITIALIZED: Sq.Tracking.ObserverName = 'sq:cdpTrackerInitialized';

const pwtHelper = {
  dependentsSubscribed: false,
  isPwtReady: false,
  isPageLevelDependentsLoaded: false,
  isDependentsLoaded: false,
  pageLevelDependents: [
    oneLinkHelper,
    ctaLinkTrackingHelper,
    datadogRumHelper,
    driftHelper,
    optimizelyHelper,
    modalHelper,
    munchkinHelper,
  ] as Array<PwtDependent>,
  dependents: [] as Array<PwtDependent>,
  permissions: {} as InitializationProperties,

  isBrowser: (): boolean => typeof window !== 'undefined',

  setPermissions(permissions: InitializationProperties) {
    if (Object.keys(pwtHelper.permissions).length === 0) {
      pwtHelper.permissions = permissions;
    }
  },

  setIsPageLevelDependentsLoaded: () => {
    pwtHelper.isPageLevelDependentsLoaded = true;
  },
  setIsDependentsLoaded: () => {
    pwtHelper.isDependentsLoaded = true;
  },

  addDependent(dependent: PwtDependent) {
    if (pwtHelper.isDependentsLoaded) {
      dependent.initialize(pwtHelper.permissions);
    } else {
      pwtHelper.dependents.push(dependent);
    }
  },
  subscribeDependents: () => {
    if (!pwtHelper.isBrowser() || pwtHelper.dependentsSubscribed) {
      return;
    }

    pwtHelper.dependentsSubscribed = true;
    window.Sq.Tracking.subscribe(TRACKERS_INITIALIZED, (ev: CustomEvent<Sq.Tracking.InitializationProperties>) => {
      pwtHelper.setPermissions(ev.detail);
      pwtHelper.setIsPageLevelDependentsLoaded();
      pwtHelper.setIsDependentsLoaded();

      // page dependents are initialized first
      pwtHelper.pageLevelDependents.forEach((d: PwtDependent) => {
        d.initialize(ev.detail);
      });

      // then other dependents
      pwtHelper.dependents.forEach((d: PwtDependent) => {
        d.initialize(ev.detail);
      });
    });
  },
};

export default pwtHelper;
